// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import "./controllers"
import * as ActiveStorage from "@rails/activestorage"
ActiveStorage.start()
import "trix"
import "@rails/actiontext"
// Niente allegati nei rich text (dettagli piano): solo formattazione.
document.addEventListener("trix-file-accept", (e) => e.preventDefault())
